import React, { Component, PropTypes } from 'react';
import { ReactSparkSelectInput } from '../../../widgets/index';
import { connect } from 'react-redux';

const FontPropertySelect = ({ label, values, defaultValue, onChange, isDisabled }) => {
    return (
        <div className="col-xs-12 col-sm-4">
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                isDisabled={isDisabled}
                defaultValue={defaultValue}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

FontPropertySelect.propTypes = {
    backgroundColor: PropTypes.object
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.filterBar, ...state.theme.filterBar };
};

export default connect(mapStateToProps)(FontPropertySelect);



// WEBPACK FOOTER //
// ./src/components/pages/theme/calendar/FontPropertySelect.js